
import { StatusDtoOrderStatusEnum } from 'utils/types/OrderModels';
import { SubscriptionPurchaseStateType } from 'utils/types/Subscription';

import { AccountFormData, initialAccountState, initialErrorState, initialInvoiceState, InvoiceFormData } from 'components/common/Purchase/ProductPurchaseForm';

export const SUBSCRIPTION_PRODUCT_ID = 3;

export const POLLING_INTERVAL_MS = 5000;
export const POLLING_TIMEOUT_MS = 18 * 60 * 1000;

export const subscriptionPurchaseInitialState: SubscriptionPurchaseStateType = {
    accountData: initialAccountState,
    invoiceData: initialInvoiceState,
    errors: initialErrorState,
    triggerValidation: false,
    processStep: '',
    isLoading: false,
    isPolling: false,
    status: StatusDtoOrderStatusEnum.PENDING,
    showPurchaseStatus: false,
    currentOrder: null,
    pollingIntervalRef: null,
    error: '',
    subscriptionProduct: null
};

export const isAccountDataFilled = (accountData: AccountFormData) => {
    return accountData.email || accountData.password || accountData.confirmPassword;
};

export const isInvoiceDataFilled = (invoiceData: InvoiceFormData) => {
    return invoiceData.firstName || invoiceData.lastName || invoiceData.street || invoiceData.city || invoiceData.postalCode;
};

export const initialState = {
    subscriptionPurchaseInitialState: () => subscriptionPurchaseInitialState
};
